import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Alert from "react-s-alert";
import moment from "moment";
import { api, filterHelper, uiHelper, constant, dateHelper } from "../helpers";
import { DashboardInfoCard, ActiveToggleFilter, SelectFilter, TextFilter, FilterSet, Pager } from ".";
import "./Site.css";
import _ from "lodash";
import {
    Row,
    Col,
    Table,
    Input,
    Button,
    ButtonGroup,
    CardDeck,
    Card,
    CardHeader,
    CardBody,
    ListGroup,
    ListGroupItem,
    Label,
    Badge
} from "reactstrap";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Fragment } from "react";

const getProducts = () => api.fetch('Reference/Products').then(response => {
    return {
        productList: _.map(response.data, x => { return uiHelper.resolveValue(null, x.id, x.name); })
    };
}).catch(x => console.error(x));
const getFacilities = () => api.fetch('Reference/Facilities').then(response => {
    return {
        facilityList: _.map(response.data, x => { return uiHelper.resolveValue(null, x.id, x.name); })
    };
}).catch(x => console.error(x));
const getRequestTestTypes = () => api.fetch('Reference/RequestTestTypes').then(response => {
    return {
        requestTestTypeList: _.map(response.data, x => { return uiHelper.resolveValue(null, x.id, x.name); })
    };
}).catch(x => console.error(x));
const getTestStatus = () => api.fetch('Reference/TestStatus').then(response => {
    return {
        testStatusList: _.map(response.data, x => { return uiHelper.resolveValue(null, x.id, x.name); })
    };
}).catch(x => console.error(x));
const getRequestTestCategory = () => api.fetch('Reference/RequestTestCategories').then(response => {
    return {
        requestTestCategoryList: _.map(response.data, x => { return uiHelper.resolveValue(null, x.id, x.name); })
    };
}).catch(x => console.error(x));
const getRequestStatusCount = () => api.post('COA/GetRequestStatusCounts').then(response => {
    return {
        statusCounts: response.data
    };
}).catch(x => console.error(x));
const emptyRequest = () => {
    return {
        product: null,
        productAlias: '',
        lotNumber: '',
        status: Object.assign({}, constant.REQUEST_STATUS.PENDING),
        facility: null,
        dateRequested: null,
        category: null,
        requestTestTypes: [],
    };
}

const resolveStatusColor = (status) => {
    switch (status) {
        case constant.REQUEST_STATUS.COMPLETED.label:
            return "cbdmdSuccess"
            break;
        case constant.REQUEST_STATUS.IN_PROGRESS.label:
            return "cbdmdPrimary"
            break;
        default:
            return "cbdmdSecondary"
    }
}

export default class RequestLog extends Component{
    static displayName = RequestLog.name;

    constructor(props) {
        super(props);
        this.state = {
            filters: [],
            pagedList: null,
            sortColumn: "Id",
            sortAscending: true,
            productList: [],
            facilityList: [],
            requestTestTypeList: [],
            requestTestCategoryList: [],
            testStatusList: [],
            loading: true,
            editRequest: null,
            statusCounts: null
        };
        this.refreshList = this.refreshList.bind(this);
        this.addNewRequest = this.addNewRequest.bind(this);
        this.cancelRequest = this.cancelRequest.bind(this);
        this.onNewRequestChange = this.onNewRequestChange.bind(this);
        this.onTestTypeChange = this.onTestTypeChange.bind(this);
        this.onRemoveTestType = this.onRemoveTestType.bind(this);
        this.onSave = this.onSave.bind(this);
        this.onEditRequest = this.onEditRequest.bind(this);
        this.onViewRequestHistory = this.onViewRequestHistory.bind(this);
        this.toggleRequestActive = this.toggleRequestActive.bind(this);
        this.setPage = this.setPage.bind(this);
        this.clearFilters = this.clearFilters.bind(this);
        this.onChangeFilter = this.onChangeFilter.bind(this);
        this.updateStatusCount = this.updateStatusCount.bind(this);
        this.downloadReport = this.downloadReport.bind(this);
    }

    componentDidMount() {
        this.updateStatusCount();
        Promise.all([getProducts(), getFacilities(),
            getRequestTestTypes(), getRequestTestCategory(),
            getTestStatus()//, getRequestStatusCount()
        ]).then(response => {
            let newStatus = {};
            _.each(response, r => Object.assign(newStatus, r));
            this.setState(newStatus, () => {
                this.onChangeFilter({
                    filterName: "activeOnly",
                    value: true,
                    filteredDisplay: "Active Only"
                });
            });
        });
    }

    refreshList(sortColumn, sortAscending, filters, pageNumber) {
        this.setState({ loading: true });
        const resolvedFilters = filters || this.state.filters;
        const resolvedSort = {
            sortColumn: sortColumn || this.state.sortColumn,
            sortAscending: sortAscending || this.state.sortAscending
        };
        const payload = {
            activeOnly: null,
            name: null,
            ...resolvedSort,
            ...filterHelper.filtersToObject(resolvedFilters),
            pageSize: 50,
            page: pageNumber || (this.state.pagedList ? this.state.pagedList.pageNumber : 1)
        };
        api.post("COA/GetPagedRequestLogs", payload)
            .then(response => {
                if (response.data) {
                    let list = _.map(response.data.dataSource, l => {
                        l.collapsed = false;
                        l.product = uiHelper.resolveValue(null, l.productId, l.productName);
                        l.facility = uiHelper.resolveValue(null, l.facilityId, l.facilityName);
                        l.category = uiHelper.resolveValue(null, l.categoryId, l.categoryName);
                        l.status = uiHelper.resolveValue(null, l.testStatusId, l.testStatusName);
                        l.dateRequested = moment(l.dateRequested).toDate();
                        l.requestTestTypes = _.map(l.requestedProductTests, s => {
                            let testType = _.find(this.state.requestTestTypeList, t => { return t.value === s.requestedTestTypeId });
                            s.value = s.requestedTestTypeId;
                            s.label = testType.label;
                            return s;
                        })
                        return l;
                    });
                    this.setState({
                        ...resolvedSort,
                        pagedList: {
                            list: list,
                            pageNumber: response.data.page,
                            pageSize: response.data.pageSize,
                            totalItems: response.data.totalItems,
                            totalPages: response.data.totalPages
                        },
                        filters: resolvedFilters,
                        loading: false
                    });
                }
            })
        this.updateStatusCount();
    }

    updateStatusCount() {
        api.post('COA/GetRequestStatusCounts')
            .then(response => {
            this.setState({
                statusCounts: response.data
            });
        }).catch(x => console.error(x))
    }

    setPage(page) {
        this.refreshList(null, null, null, page);
    }

    clearFilters() {
        const filters = [];
        this.setState({ filters: filters });
        this.refreshList(null, null, filters);
    }

    onChangeFilter(changedFilter) {
        const filters = filterHelper.getFilters(this.state.filters, changedFilter);
        this.setState({ filters: filters });
        this.refreshList(null, null, filters, 1);
    }

    onNewRequestChange(e, fieldName) {
        let request = Object.assign({}, this.state.editRequest);
        request[fieldName] = e.target ? e.target.value : e;
        this.setState({ editRequest: request });
    }

    addNewRequest() {
        window.scrollTo(0, 0)
        this.setState({ editRequest: emptyRequest() });
    }

    cancelRequest() {
        this.setState({ editRequest: null });
    }

    onTestTypeChange(selection) {
        let request = Object.assign({}, this.state.editRequest);
        let alreadyExist = _.find(request.requestTestTypes, t => { return t.value === selection.value })
        if (alreadyExist) return;
        request.requestTestTypes.push(selection);
        this.setState({ editRequest: request });
    }

    onRemoveTestType(testTypeId) {
        let request = Object.assign({}, this.state.editRequest);
        request.requestTestTypes = _.reject(request.requestTestTypes, r => {
            return r.value === testTypeId
        });
        this.setState({ editRequest: request });
    }

    validateLog(request) {
        let warnings = [];
        if (!request.product) {
            warnings.push("Product is required");
        }
        if (!request.lotNumber) {
            warnings.push("Lot Number is required");
        }
        if (!request.facility) {
            warnings.push("Facility is required");
        }
        if (!request.requestTestTypes || !request.requestTestTypes.length) {
            warnings.push("At least one Test Type is required");
        }
        if (!request.category) {
            warnings.push("Category is required");
        }
        if (!request.dateRequested) {
            warnings.push("Date Requested is required");
        }
        if (warnings.length > 0) {
            Alert.error(warnings.join(", "));
        } 
        return warnings.length === 0;
    }

    onSave() {
        let request = Object.assign({}, this.state.editRequest);

        if (!this.validateLog(request)) return;
        let payload = {
            ProductId: request.product.value,
            ProductAlias: request.productAlias,
            FacilityId: request.facility.value,
            LotNumber: request.lotNumber,
            CategoryId: request.category.value,
            DateRequested: request.dateRequested,
            TestStatusId: request.status.value,
            RequestedProductTests: _.map(request.requestTestTypes, r => {
                if (request && request.id) {
                    r.RequestedTestId = request.id
                }
                r.RequestedTestTypeId = r.value
                return r
            })
        }
        if (request.id) {
            payload.Id = request.id;
        }

        api.post("COA/SaveRequestLog", payload)
            .then(response => {
                if (response.data && response.data.success) {
                    Alert.success("Request was successfully saved.")
                    this.setState({
                        editRequest: null
                    }, () => {
                        this.refreshList();
                       // this.updateStatusCount();

                    });
                } else {
                    Alert.error(response.data.message || "An error occurred saving your request.")
                }
            }).catch(error => {
                Alert.error("Something went wrong. Request cannot be saved at this time.")
            })
    }

    toggleRequestActive(requestId) {
        if (!requestId) return;
        api.post(`COA/ToggleRequestLogActive/${requestId}`)
            .then(response => {
                if (response && response.data && response.data.success) {
                    Alert.success("Request has been updated.")
                    this.refreshList();
                    //this.updateStatusCount();
                } else {
                    Alert.error("An error occurred. Request cannnot be updated at this time.")
                }
            })
            .catch(error => {Alert.error(error)})
    }
    onEditRequest(requestId) {
        let list = this.state.pagedList.list.slice();
        let request = _.find(list, l => { return l.id === requestId });
        if (!request) return;
        this.setState({ editRequest: request });
        window.scrollTo(0,0)
    }

    onViewRequestHistory(requestId) {
        let list = this.state.pagedList.list.slice();
        let index = _.findIndex(list, l => { return l.id === requestId });
        list[index].collapsed = !list[index].collapsed;
        api.post(`COA/GetRequestedTestHistory/${list[index].id}`)
            .then(r => {
                if (r.data) {
                    list[index].history = _.map(r.data, d => {
                        d.updatedAt = dateHelper.localDateTime(d.updatedAt);
                        return d;
                    });
                }
                this.setState({ pagedList: { ...this.state.pagedList, list: list } });
            })
    }

    downloadReport() {
        const resolvedFilters = this.state.filters;
        const resolvedSort = {
            sortColumn: this.state.sortColumn,
            sortAscending: this.state.sortAscending
        };
        const payload = {
            activeOnly: null,
            name: null,
            ...resolvedSort,
            ...filterHelper.filtersToObject(resolvedFilters),
        };
        api.postFormDataGetBlob(`COA/DownloadRequestLogXLSx`, payload)
            .then(response => {
                if (response.status === 200) {
                    const XLSX_MIME = "application/vnd.openxmlformats-officedocument.spreadsheetml";
                    const XLSX_FILENAME = `Request_Log_List.xlsx`;
                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(response.data, XLSX_FILENAME);
                    }
                    else {
                        const file = new Blob([response.data], { type: XLSX_MIME });
                        var anchor = window.document.createElement('a');
                        anchor.download = XLSX_FILENAME;
                        anchor.href = (window.webkitURL || window.URL).createObjectURL(file);
                        anchor.dataset.downloadurl = [XLSX_MIME, anchor.download, anchor.href].join(':');
                        anchor.click();
                    }
                } else {
                    throw new Error("Error downloading report");
                }
            }).catch(error => Alert.error(error));
    }
    
    render() {
        const {
            editRequest,
            productList,
            facilityList,
            requestTestTypeList,
            requestTestCategoryList,
            statusCounts,
            pagedList,
            loading
        } = this.state;
        return (
            <div className="ml-4 mr-4">
                <Row className="pageTitle p-2 mb-3">
                    <Col>
                        <h4>Testing Request Logs</h4>
                    </Col>
                </Row>

                <Row>
                    {statusCounts &&
                        statusCounts.map(info => (
                            
                            <Col>
                                <div className="cursor" onClick={
                                ()=>{
                                    let statusFilter = _.find(this.state.testStatusList, f => f.label === info.statusName);
                                    this.onChangeFilter({
                                        filterName: "testStatusId",
                                        value: statusFilter.value,
                                        filteredDisplay: `Status: ${statusFilter.label}`
                                        });
                                }
                                }>
                                <DashboardInfoCard
                                    name={info.statusName}
                                    count={info.count}
                                />
                                </div>
                            </Col>
                            
                        ))
                    }
                </Row>

                {editRequest && (
                    <Card className="p-4 mb-2">
                        <CardHeader className="boldText">{editRequest.id && editRequest.id > 0 ? "Edit" : "Create"} Request</CardHeader>
                        <Row className="mb-2">
                            <Col>
                                Product
                                <Select
                                    options={productList}
                                    onChange={(e) => this.onNewRequestChange(e, "product")}
                                    value={editRequest.product}
                                />
                            </Col>
                            <Col>Product Alias
                                <Input type="text" name="productAlias" onChange={(e) => this.onNewRequestChange(e, "productAlias")} value={editRequest.productAlias} />
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col>
                                Facility
                                <Select
                                    options={facilityList}
                                    onChange={(e) => this.onNewRequestChange(e, "facility")}
                                    value={editRequest.facility}
                                />
                            </Col>
                            <Col>Lot Number
                                <Input type="text" name="lotNumber" onChange={(e) => this.onNewRequestChange(e, "lotNumber")} value={editRequest.lotNumber} />
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col>
                                Category
                                <Select
                                    options={requestTestCategoryList}
                                    onChange={(e) => this.onNewRequestChange(e, "category")}
                                    value={editRequest.category}
                                />
                            </Col>
                            <Col>
                                <Label>Date Requested</Label>
                                <div>
                                    <DatePicker
                                        selected={editRequest.dateRequested}
                                        className="form-control"
                                        placeholderText="Select a date"
                                        onChange={date => this.onNewRequestChange(date, "dateRequested")}
                                    />
                                </div>
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col xs="6">
                                Test Types
                                <Select
                                    options={requestTestTypeList}
                                    onChange={(e) => this.onTestTypeChange(e)}
                                />
                            </Col>
                        </Row>

                        {editRequest.requestTestTypes && editRequest.requestTestTypes.length > 0 &&
                            <Row className="mb-2">
                                <Col>
                                    <ListGroup>
                                        <ListGroupItem>
                                            {editRequest.requestTestTypes.map((t, idx) => (
                                                <span key={`rtt-${t.value}-${idx}`} className="mr-2">
                                                    <span className="mr-1">{t.label}</span>
                                                    <span className="cbdmdDangerText cursor"><FontAwesomeIcon icon="times" onClick={() => this.onRemoveTestType(t.value)} /></span>
                                                </span>
                                            ))}
                                        </ListGroupItem>
                                    </ListGroup>
                                </Col>
                            </Row>
                        }
                        <Row>
                            <Col>
                                <ButtonGroup className="mt-2 float-right">
                                    <Button size="sm" color="secondary" onClick={this.cancelRequest}>Cancel</Button>
                                    <Button size="sm" color="primary" onClick={this.onSave}>Save</Button>
                                </ButtonGroup>
                            </Col>
                        </Row>
                    </Card>
                )}

                <Card className="p-2">
                    <Row className="p-2">
                        <Col>
                            {/*Filters*/}
                            <Row className="rowSpacing cursor">
                                <Col>
                                    <FilterSet
                                        filters={this.state.filters}
                                        clearFilters={this.clearFilters}
                                        childrenClassName="pt-2 cursor"
                                    >
                                        <Col xs="3">
                                            <TextFilter
                                                filterName="productAlias"
                                                displayName="Product Alias"
                                                descriptionPrefix="contains"
                                                onChangeCallback={this.onChangeFilter}
                                            />
                                        </Col>
                                        <Col xs="3">
                                            <TextFilter
                                                filterName="lotNumber"
                                                displayName="Lot Number"
                                                descriptionPrefix="contains"
                                                onChangeCallback={this.onChangeFilter}
                                            />
                                        </Col>
                                        <Col xs="3">
                                            <SelectFilter
                                                filterName="productId"
                                                displayName="Product"
                                                isSingleSelect={true}
                                                options={this.state.productList}
                                                onChangeCallback={this.onChangeFilter}
                                                value={filterHelper.getSelectValue(
                                                    "productId",
                                                    this.state.filters
                                                )}
                                            />
                                        </Col>

                                        <Col xs="3">
                                            <SelectFilter
                                                filterName="facilityId"
                                                displayName="Facility"
                                                isSingleSelect={true}
                                                options={this.state.facilityList}
                                                onChangeCallback={this.onChangeFilter}
                                                value={filterHelper.getSelectValue(
                                                    "facilityId",
                                                    this.state.filters
                                                )}
                                            />
                                        </Col>
                                        <Col xs="3">
                                            <SelectFilter
                                                filterName="testStatusId"
                                                displayName="Status"
                                                isSingleSelect={true}
                                                options={this.state.testStatusList}
                                                onChangeCallback={this.onChangeFilter}
                                                value={filterHelper.getSelectValue(
                                                    "testStatusId",
                                                    this.state.filters
                                                )}
                                            />
                                        </Col>
                                        <Col xs="2">
                                            <ActiveToggleFilter
                                                filterName="activeOnly"
                                                displayName="Active Only"
                                                onChangeCallback={this.onChangeFilter}
                                                value={filterHelper.get_value(
                                                    "activeOnly",
                                                    this.state.filters
                                                )}
                                            />
                                        </Col>
                                    </FilterSet>
                                </Col>
                            </Row>

                            {/*TABLE*/}
                            <Row className="p-2 mt-2">
                                {loading ? (
                                    <Col className="centerText">
                                        <FontAwesomeIcon icon="spinner" size="9x" spin className={"cbdmdBlueText"} />
                                    </Col>
                                ) : (
                                    <Col>
                                        <Table size="sm" responsive striped>
                                            <thead>
                                                 <tr>
                                                    <th>Id</th>
                                                    <th>Request Details</th>
                                                    <th>Status</th>
                                                        <th>
                                                            <ButtonGroup className="float-right">
                                                        {!editRequest &&
                                                            <Button
                                                                color="success"
                                                                className="float-right"
                                                                size="sm"
                                                                onClick={this.addNewRequest}
                                                            >
                                                                Add New Request
                                                            </Button>
                                                                }
                                                                <Button size="sm" color="dark" title="Download Request Log" className="buttonGroupSpacing" onClick={() => this.downloadReport()}>
                                                                    <FontAwesomeIcon icon="download" />
                                                                </Button>
                                                                </ButtonGroup>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {pagedList && pagedList.list && pagedList.list.length > 0
                                                        ? (pagedList.list.map((l, index) => (
                                                        <Fragment>
                                                        <tr key={`rq-${l.id}-${index}`}>
                                                            <td>{l.id}</td>
                                                            <td>
                                                                <Row>
                                                                    <Col >
                                                                        <div>
                                                                            <span className="primaryTextTitle">Product:</span> {l.product && l.product.label}
                                                                        </div>
                                                                        <div>
                                                                            <span className="primaryTextTitle">Category:</span> {l.category && l.category.label}
                                                                        </div>
                                                                        <div>
                                                                            <span className="primaryTextTitle">Test Types:</span> {l.requestTestTypeString && l.requestTestTypeString}
                                                                        </div>
                                                                    </Col>
                                                                    <Col>
                                                                        <div>
                                                                            <span className="primaryTextTitle">Facility:</span> {l.facility && l.facility.label}
                                                                        </div>
                                                                        <div>
                                                                            <span className="primaryTextTitle">LotNumber:</span> {l.lotNumber && l.lotNumber}
                                                                        </div>
                                                                        <div>
                                                                            <span className="primaryTextTitle">Date Requested:</span> {l.dateRequested && moment(l.dateRequested).format('MM/DD/YYYY')}
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            </td>
                                                            <td>
                                                                {l.status && l.status.label &&
                                                                   <Badge className={`${resolveStatusColor(l.status.label)} boldText fontSize14`}>{l.status && l.status.label}</Badge>
                                                                }
                                                            </td>
                                                            <td>
                                                                <ButtonGroup className="float-right">
                                                                    {!l.deactivatedAt
                                                                        ? <Fragment>
                                                                            <Button
                                                                                size="sm"
                                                                                outline={l.collapsed}
                                                                                color={"dark"}
                                                                                title="View History"
                                                                                onClick={() => this.onViewRequestHistory(l.id)}
                                                                                disabled={editRequest}
                                                                            >
                                                                                <FontAwesomeIcon icon="list" />
                                                                            </Button>
                                                                            <Button
                                                                                size="sm"
                                                                                color="primary"
                                                                                title="Edit Request"
                                                                                onClick={() => this.onEditRequest(l.id)}
                                                                                disabled={editRequest}
                                                                            >
                                                                                <FontAwesomeIcon icon="edit" />
                                                                            </Button>
                                                                            <Button
                                                                                size="sm"
                                                                                color="danger"
                                                                                title="Delete Request"
                                                                                onClick={() => this.toggleRequestActive(l.id)}
                                                                                disabled={editRequest}
                                                                            >
                                                                                <FontAwesomeIcon icon="times" />
                                                                            </Button>
                                                                        </Fragment>
                                                                        : <Button
                                                                            size="sm"
                                                                            color="info"
                                                                            title="Revive Request"
                                                                            onClick={() => this.toggleRequestActive(l.id)}
                                                                            disabled={editRequest}
                                                                        >
                                                                            <FontAwesomeIcon icon="reply" />
                                                                        </Button>
                                                                    }
                                                                </ButtonGroup>
                                                            </td>
                                                        </tr>
                                                            {l.collapsed &&
                                                                <Fragment>
                                                                    <tr>
                                                                        <td colSpan={12}>
                                                                        <ListGroup>
                                                                            {l.history && l.history.length > 0 
                                                                                ? l.history.map(h => (
                                                                                    <ListGroupItem key={`history-${h.id}`}>
                                                                                        <Row>
                                                                                            <Col>
                                                                                                <div><span className="boldText">Product:</span> <span className="italicText"> {h.productName}</span></div>
                                                                                                <div><span className="boldText">Product Alias:</span> <span className="italicText"> {h.productAlias}</span></div>
                                                                                                <div><span className="boldText">Lot Number:</span> <span className="italicText"> {h.lotNumber}</span></div>
                                                                                            </Col>
                                                                                            <Col>
                                                                                                <div><span className="boldText">Facility:</span> <span className="italicText"> {h.facilityName}</span></div>
                                                                                                <div><span className="boldText">Category:</span> <span className="italicText"> {h.categoryName}</span></div>
                                                                                                <div><span className="boldText">Test Types:</span> <span className="italicText"> {h.testTypeNames}</span></div>
                                                                                            </Col>
                                                                                            <Col xs="2">
                                                                                                <div><span className="boldText">Updated At:</span> <span className="italicText">{h.updatedAt}</span></div>
                                                                                                <div><span className="boldText">Updated By:</span> <span className="italicText"> {h.updatedByUserName}</span></div>
                                                                                                <div><span className="boldText">Status:</span> <Badge className={`${resolveStatusColor(h.testStatusName)} boldText italicText`}>{h.testStatusName}</Badge></div>
                                                                                            </Col>
                                                                                        </Row>
                                                                                    </ListGroupItem>
                                                                                 )) :
                                                                                <ListGroupItem>No History</ListGroupItem>
                                                                            }
                                                                            </ListGroup>
                                                                        </td>
                                                                    </tr>
                                                                </Fragment>
                                                             }
                                                       </Fragment>
                                                    ))) : null
                                                }
                                            </tbody>
                                        </Table>
                                        <Pager {...this.state.pagedList} callBack={this.setPage} />
                                    </Col>
                                )}
                            </Row>
                        </Col>
                    </Row>
                </Card>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/RequestLog.js